import ScienceIcon from '@mui/icons-material/Science';
import { Button, Chip, Stack, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { type FC } from 'react';

import { type VisionSnippet } from '../../api/index.js';

interface Props {
  snippet: VisionSnippet;
  onReplay: () => void;
}

const VisionSnippetRow: FC<Props> = ({ snippet, onReplay }) => (
  <Stack
    direction={'row'}
    alignItems={'center'}
    spacing={1}
    sx={{ p: 1, border: 1, borderColor: 'divider', borderRadius: 1 }}
  >
    <Stack sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant={'body2'}>
        {DateTime.fromISO(snippet.createdAt).toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS)}
      </Typography>
      <Typography variant={'caption'} color={'text.secondary'}>
        {Math.round(snippet.durationMs / 1000)} s
      </Typography>
    </Stack>
    <Chip label={snippet.source} size={'small'} variant={'outlined'} sx={{ height: 20, fontSize: 11 }} />
    {snippet.url && (
      <Button size={'small'} href={snippet.url} target={'_blank'} rel={'noreferrer'}>
        Video
      </Button>
    )}
    <Button size={'small'} startIcon={<ScienceIcon />} onClick={onReplay}>
      Replay
    </Button>
  </Stack>
);

export default VisionSnippetRow;
